import {AfterContentInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {debounceTime} from 'rxjs/operators';


export const FILTER_DEBOUNCE_TIME = 350;

@Component({
  selector: 'app-filter-section',
  template: `
    @if (all || filtered) {
      <section class="cl-section cl-section-tight">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <details class="card cl-tight cl-color-haze" style="width: 100%;"
                       [open]="searchOpen"
                       (toggle)="onToggle($event)">
                <summary class="card-header">
                  @if (all && filtered) {
                    <div>Filter: {{ (filtered || []).length }}
                      of {{ (all || []).length }} shown
                    </div>
                  }
                  @if (!all && filtered) {
                    <div>Search: {{ (filtered || []).length }} results
                    </div>
                  }
                </summary>
                <div class="card-body">
                  @if (formGroup) {
                    <div #filterContent>
                    <ng-content></ng-content>
                  </div>}
                </div>
              </details>
            </div>
          </div>
        </div>
      </section>
    }
  `,
  styleUrls: ['./filter-section.component.scss'],
  imports: []
})
export class FilterSectionComponent implements AfterContentInit, OnChanges {
  @Input() openByDefault = false;
  @Input() all: any[] | null;
  @Input() filtered: any[] | null;
  @Input() formGroup: FormGroup;
  @ViewChild('filterContent', {read: ElementRef}) filterContent: ElementRef;

  searchOpen = false;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {

  }

  onToggle(event: Event) {
    this.searchOpen = (event.target as HTMLDetailsElement).open;
    if (this.searchOpen) {
      // Focus the first input when opened
      setTimeout(() => {
        const firstInput = this.filterContent?.nativeElement.querySelector('input[type="text"]');
        if (firstInput) {
          firstInput.focus();
        }
      }, 0);
    }
  }

  filterEmptyParams(params: { [key: string]: any }): { [key: string]: any } {
    const filteredParams: { [key: string]: any } = {};
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== '' && params[key]) {
        filteredParams[key] = params[key];
      }
    });
    return filteredParams;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['openByDefault'] && changes['openByDefault'].currentValue) {
      this.searchOpen = true;
    }
    if (changes['all'] && this.all && this.all.length > 5 && !this.searchOpen) {
      this.searchOpen = true;
    }
    if (this.all && this.filtered && this.all.length !== this.filtered.length) {
      this.searchOpen = true;
    }
  }

  ngAfterContentInit(): void {
    // Only set searchOpen from openByDefault if it hasn't already been set by ngOnChanges
    if (!this.searchOpen) {
      this.searchOpen = this.openByDefault;
    }
    this.formGroup.valueChanges.pipe(debounceTime(FILTER_DEBOUNCE_TIME)).subscribe(val => {
      const mergedParams = Object.assign([], this.activatedRoute.snapshot.queryParams, val)
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: this.filterEmptyParams(mergedParams)
      })
    });
    this.activatedRoute.queryParams.subscribe(params => {
      setTimeout(() => { // Delay to ensure we are no longer in the initial change detection cycle (will trigger warning)
        const values = this.formGroup.value;
        Object.keys(values).forEach(key => {
          if (params[key] !== undefined && params[key] !== null) {
            this.formGroup.controls[key].setValue(params[key]);

          }
        });

      })
    })
  }
}
